@if (data.message; as message) {
  <section class="py-7">
    <div
      class="centered-with-padding flex flex-col items-center justify-center rounded-[35px] bg-gray-light px-5 py-10 text-center desk:px-11 desk:text-[24px] desk:leading-6">
      {{ data.message }}
    </div>
  </section>
}
